import { render, staticRenderFns } from "./takeaway.vue?vue&type=template&id=465a461a"
import script from "./takeaway.vue?vue&type=script&lang=js"
export * from "./takeaway.vue?vue&type=script&lang=js"
import style0 from "./takeaway.vue?vue&type=style&index=0&id=465a461a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports